import { Routes } from '@angular/router';
import { AppMainComponent } from 'src/app/shared/utilities/app.main.component';
import { AuthorizatedGuard } from './authentication/auth.guard';
import { RoutesEnum } from './constants/RoutesEnum';
import { BlankComponent } from './layouts/blank/blank.component';


export const APPRoutes: Routes = [
  {
    path: RoutesEnum.Root,
    component: AppMainComponent,
    canActivate: [AuthorizatedGuard],
    children: [
      { path: RoutesEnum.Root, redirectTo: `/${RoutesEnum.MyMachines}`, pathMatch: 'full' },
      {
        path: RoutesEnum.Home,
        loadChildren: () => import('./home/home.module'),
        canActivate: [AuthorizatedGuard],
      },
      {
        path: RoutesEnum.Users,
        loadChildren: () => import('./usuarios/usuario.module').then(m => m.UsuarioModule),
        canActivate: [AuthorizatedGuard],
      },
      {
        path: RoutesEnum.MyMachines,
        loadChildren: () => import('./mapa/reporte.module').then(m => m.ReporteModule),
        canActivate: [AuthorizatedGuard],
      },
      {
        path: RoutesEnum.Machines,
        loadChildren: () => import('./maquinas/maquina.module').then(m => m.MaquinaModule),
        canActivate: [AuthorizatedGuard],
      },
      {
        path: RoutesEnum.Companies,
        loadChildren: () => import('./empresas/empresa.module').then(m => m.EmpresaModule),
        canActivate: [AuthorizatedGuard],
      },
      {
        path: RoutesEnum.Maintenance,
        loadChildren: () => import('./mantenimiento/mantenimiento.module').then(m => m.MantenimientoModule),
        canActivate: [AuthorizatedGuard],
      },
    ]
  },
  {
    path: RoutesEnum.Root,
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/authentication/404'
  }
];
